import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

import { FootnoteService } from './footnote.service';

/**
 * hcfFootnote directive is used to render <sup> element containing a footnote index and text.
 */
@Directive({
  selector: '[hcfFootnote]',
  standalone: false,
})
export class FootnoteDirective implements OnChanges {
  @Input() footnoteText: string;

  constructor(
    private _el: ElementRef,
    private _footnoteSerivice: FootnoteService,
  ) {}

  ngOnChanges() {
    const footNote = this._footnoteSerivice.getFootnote(this.footnoteText);
    if (footNote) {
      this._el.nativeElement.setAttribute('title', footNote.text);
      this._el.nativeElement.innerHTML = footNote.index;
    }
  }
}
